export const SET_UNPAID_ORDERS_MODAL = 'SET_UNPAID_ORDERS_MODAL'
export const CLEAR_UNPAID_ORDERS_MODAL = 'CLEAR_UNPAID_ORDERS_MODAL'
